import React, { useState } from "react";
import { HelpCircle, Phone } from "lucide-react";
import OfferteForm from "./OfferteForm";

function HelpButton() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsFormOpen(true)}
        className="fixed bottom-[1.22rem] right-8 bg-white rounded-full w-10 h-10 flex items-center text-[#2FB6D2] justify-center shadow-lg hover:bg-[#2FB6D2]/80 transition-colors z-50"
      >
        <HelpCircle className="w-6 h-6" />
      </button>

      <OfferteForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />

      <div className="lg:hidden fixed bottom-0 left-0 right-0 p-4 bg-white shadow-lg z-40">
        <a
          href="tel:+31852129778"
          className="flex items-center justify-center gap-2 bg-[#17354A] text-white py-3 px-6 rounded-full hover:bg-[#17354A]/80 transition-colors w-full max-w-md mx-auto"
        >
          <Phone className="w-5 h-5" />
          <span className="font-medium"> 085-2129778          </span>
        </a>
      </div>
    </>
  );
}

export default HelpButton;
